module.exports = __webpack_public_path__ + "static/media/logo_groupe_gamache_en.3c2922ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_groupe_gamache_en.png
// module id = 81
// module chunks = 0